import QrReader from "../QrReader.vue";
import LossReasonSelect from "../LossReasonSelect.vue";
import OrderList from "../OrderList.vue";
import CakeQuestion from "../CakeQuestion.vue";
import { setBranchCart, addToCartFromCart, removeToCart, unReserveTable, triggerKitchenPrintBySID } from "@/api/Cart";
import { getAllKitchen } from "@/api/Kitchen";
import { uuid } from "vue-uuid";
import Printer from "../Printer.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  props: {
    cartEntryOpened: {
      type: Boolean,
      default: false,
    },
    isKiosk: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      baskets: [],
      basketCount: 0,
      selected: "",
      moment: require("moment-timezone"),
      currentTime: "",
      isNotePopupOpen: false,
      selectedNote: "",
      tableHeight: "auto !important",
      printeractive: false,
      orderBillEntries: [],
      totalOriginPrice: 0,
      totalDiscountPrice: 0,
      orderBillNo: 0,
      isMobile: null,
      isMobileButtonOpen: false,
      isTransaction: false,
      kitchens: [],
    };
  },
  components: {
    OrderList,
    CakeQuestion,
    LossReasonSelect,
    QrReader,
    Printer,
    VuePerfectScrollbar,
  },
  mounted() {
    this.getCurrentTime();
    this.refreshCartOrderScroll();
  },
  created: async function () {
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);
    this.loadKitchens();
  },
  watch: {
    selected: {
      deep: true,
      handler(val) {
        console.log(val);
        if ((val.id || val.entries) && !this.lossMode) {
          //this.$store.dispatch("selfservice/setToUpdateEntry", null)
          // this.$store.dispatch("selfservice/setSelectedProduct", null);
          // this.$store.dispatch("selfservice/setPreSelectedProduct", null);
          // this.$nextTick(() => {
          //   this.$store.dispatch("selfservice/setToUpdateEntry", val.entries[0]);
          // });
        }
      },
    },
    toUpdateEntry(val) {
      if (!val) this.selected = "";
    },
    cartEntryOpened() {
      this.refreshCartOrderScroll();
    },
    currentCart: {
      handler() {
        this.refreshCartOrderScroll();
      },
      deep: true,
    },
    selectedLossStocks() {
      this.refreshCartOrderScroll();
    },
    lossTypeSelection() {
      this.refreshCartOrderScroll();
    },
  },
  computed: {
    isCakeQuestioned: {
      get() {
        return this.$store.getters["selfservice/getCakeQuestioned"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setCakeQuestioned", val);
      },
    },
    selectedLossStocks() {
      return this.$store.getters["selfservice/getSelectedLossStocks"];
    },
    isMobileButtonOpenGetter: {
      get() {
        return this.isMobileButtonOpen;
      },
      set(val) {
        this.isMobileButtonOpen = val;
      },
    },
    lossTypeSelection: {
      get() {
        return this.$store.getters["selfservice/getLossType"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossType", val);
      },
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      },
    },
    currentCart: function () {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    carts: function () {
      return this.$store.getters["selfservice/getCarts"];
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    activePersonal: {
      get() {
        return this.$store.getters["selfservice/getActivePersonal"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setActivePersonal", val);
      },
    },
    toUpdateEntry() {
      return this.$store.getters["selfservice/getToUpdateEntry"];
    },
    currentDate() {
      let date = this.moment().locale("tr");
      date = date.tz("Europe/Istanbul").format("ddd Do MMM");
      return date;
    },
    currentTab: {
      get() {
        return this.$store.getters["selfservice/getCurrentTab"];
      },
    },
    printerSettings() {
      return this.$store.getters["selfservice/getPrinterSettings"];
    },
    sortedPaymentGroups() {
      if (!this.currentCart || !this.currentCart.paymentGroups) return [];
      // v122: Inverse sorting (newest on top)
      return [...this.currentCart.paymentGroups].reverse();
    },
  },
  methods: {
    async loadKitchens() {
      try {
        const res = await getAllKitchen();
        this.kitchens = res.data || [];
      } catch (err) {
        console.error("CartOrder: Kitchens load failed:", err);
      }
    },
    refreshCartOrderScroll() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const scrollRef = this.$refs.cartOrderScrollbar;
          if (!scrollRef) return;

          if (typeof scrollRef.update === "function") {
            scrollRef.update();
          }
          if (scrollRef.ps && typeof scrollRef.ps.update === "function") {
            scrollRef.ps.update();
          }
        });
      });
    },
    lossReasonSelectDone() {
      this.lossMode = false;
      this.switchToTableMap();
      this.clearLossList();
    },
    toggleCartOrder() {
      this.$emit("toggleCartOrder");
    },
    checkScreen() {
      this.isMobile = window.innerWidth <= 768;
    },
    openNotePopup(note) {
      this.selectedNote = note;
      this.isNotePopupOpen = true;
    },
    calculateTotalOriginPrice: function (selectedGroups) {
      let selectedPrice = 0;
      selectedGroups.forEach((item) => {
        item.entries.forEach((entry) => {
          selectedPrice += entry.originPrice;
        });
      });
      return Math.round(selectedPrice * 100) / 100;
    },
    clearQr() {
      this.$store.dispatch("selfservice/setCurrentCartCustomer", null);
    },
    commitQrCode(customer) {
      this.$store.dispatch("selfservice/setCurrentCartCustomer", customer);
    },
    openQrReader() {
      this.$refs.qrReader.isActive = true;
    },
    submitLoss: function () {
      if (this.isTransaction) return;
      this.isTransaction = true;
      try {
        let obj = {
          stockEntries: this.selectedLossStocks,
          branchId: 0,
          userId: 0,
          type: "Stock",
        };
        this.$refs.lossReasonSelect.isActive = true;
        this.$refs.lossReasonSelect.lossData = obj;
      } finally {
        this.isTransaction = false;
      }
    },
    clearLossList() {
      if (this.selected.id)
        this.$store.dispatch(
          "selfservice/removeSelectedLossStock",
          this.selected.id
        );
      else this.$store.dispatch("selfservice/clearSelectedLossStocks");
      this.selected = "";
    },
    setBillExtras(extras) {
      if (!extras || !Array.isArray(extras)) return [];
      
      // v118.Alpha-Final-13: 0-adetli ekstraları (veya varyantı olanları) kesin olarak filtrele
      const filtered = extras.filter(ex => {
        const qty = parseFloat(ex.quantity || ex.Quantity || 0);
        const variants = ex.variants || ex.Variants || [];
        
        // Sadece miktarı > 0 olanları veya içinde seçili varyantı olanları geri döndür
        return qty > 0 || (variants.length > 0 && variants.some(v => parseFloat(v.quantity || v.Quantity || 0) > 0));
      }).map(ex => {
        const exCopy = JSON.parse(JSON.stringify(ex));
        const variants = exCopy.variants || exCopy.Variants || [];
        if (variants.length > 0) {
           const filteredV = variants.filter(v => parseFloat(v.quantity || v.Quantity || 0) > 0);
           exCopy.variants = filteredV;
           exCopy.Variants = filteredV;
        }
        return exCopy;
      });

      // v118.Alpha-Final-13: Ekstra bir güvenlik katmanı olarak 0-adetli olanları diziden tamamen at
      return filtered.filter(f => {
         const q = parseFloat(f.quantity || f.Quantity || 0);
         const v = f.variants || f.Variants || [];
         return q > 0 || v.length > 0;
      });
    },
    returnSelectedExtraVariant(extra) {
      let returnObj = [];
      extra.variants.forEach((x) => {
          returnObj.push("x" + x.quantity + " / " + x.name);
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    moveOnToOrderList() {
      this.$refs.cakeQuestion.isActive = false;
      this.$refs.orderList.isActive = true;
    },
    getCurrentTime() {
      this.currentTime = this.moment().locale("tr");
      this.currentTime = this.currentTime
        .tz("Europe/Istanbul")
        .format("H:mm:ss");
      setTimeout(this.getCurrentTime, 1000);
    },
    updateEntry: async function () {
      console.log(this.selected);
      if ((this.selected.id || this.selected.entries) && !this.lossMode) {
          //this.$store.dispatch("selfservice/setToUpdateEntry", null)
          this.$store.dispatch("selfservice/setSelectedProduct", null);
          this.$store.dispatch("selfservice/setPreSelectedProduct", null);
          this.$nextTick(() => {
            this.$store.dispatch("selfservice/setToUpdateEntry", this.selected.entries[0]);
          });
        }
    },
    ClearCart: async function () {
      // FIX: İşlem başında hedef masa/sepet bilgilerini sabitle (capture)
      const targetRealId = this.currentCart ? this.currentCart.realId : null;
      const targetCartId = this.currentCart ? this.currentCart.id : null;

      if (this.currentCart.cartEntries.length > 0 && this.selected) {
        let currentCart = _.cloneDeep(this.$store.getters["selfservice/getCurrentCart"]);
        // FIX: paymentGroups filtrelemesini selected temizlenmeden önce yap
        currentCart.paymentGroups = (currentCart.paymentGroups || []).filter(
          (x) => x.rowIndex != this.selected.rowIndex
        );
        this.$store.dispatch('selfservice/updateCartsById', [currentCart]);

        this.$store.dispatch(
          "selfservice/removeEntryFromCurrentCart",
          this.selected
        );
        this.$store.dispatch("selfservice/setToUpdateEntry", null);
      }
      
      // Store'daki güncel durumu kontrol et
      const checkCart = this.$store.getters["selfservice/getCurrentCart"];
      if (!checkCart || !checkCart.cartEntries || checkCart.cartEntries.length == 0) {
        let currentCart = _.cloneDeep(this.$store.getters["selfservice/getCurrentCart"]);
        if (currentCart) {
          currentCart.paymentGroups = [];
          this.$store.dispatch('selfservice/updateCartsById', [currentCart]);
        }
        
        // FIX: Sabitlenen ID'leri kullanarak temizlik yap
        if (targetCartId) {
          this.$store.dispatch("selfservice/removeCart", targetCartId);
        }
        this.isCakeQuestioned = false;
        
        if (targetRealId) {
          await unReserveTable(targetRealId);
        }
        
        // Masa haritasına geçiş için emit gönder
        this.$emit("switchToTableMap");
        this.$vs.notify({
          color: "success",
          title: "Sepette ürün kalmadı.",
          text: "Sepette ürün kalmadığı için masa kapatıldı.",
        });
      }
    },
    PlaceOrder: async function () {
      if (this.isTransaction) return;
      this.isTransaction = true;
      try {
        this.orderBillEntries = [];
        const cartEntries = this.currentCart ? (this.currentCart.cartEntries || []) : [];
        
        // v118.Alpha-Final-31: Filter only new/waiting entries to prevent double-adding on server
        const pendingEntries = cartEntries.filter(x => x.status === 0);

        pendingEntries.forEach((tr) => {
          this.orderBillEntries.push({
            productId: tr.productId,
            childProductId: tr.childProductId,
            productQuantity: tr.quantity,
            quantity: tr.quantity,
            productName: tr.productName,
            // v118.Beta-Final-8: Kesin İzolasyon -> Reçeteyi kopyalayarak 'Ghost Ingredient' sızıntısını engelle
            recipe: tr.recipe ? _.cloneDeep(tr.recipe) : null,
            steps: tr.recipe && tr.recipe.steps ? _.cloneDeep(tr.recipe.steps) : [],
            recipeSteps: tr.recipe && tr.recipe.steps ? _.cloneDeep(tr.recipe.steps) : [],
            variantItems: tr.recipe && tr.recipe.steps ? _.cloneDeep(tr.recipe.steps).filter(
              (x) => x.selected == true && x.isDefault == false
            ) : [],
            extras: this.setBillExtras(tr.extras),
            price: parseFloat(tr.price) || 0, // v118.Beta-Final-4: Use line total for consistent UI
            originPrice: parseFloat(tr.originPrice || tr.price) || 0, 
            rawProduct: tr.rawProduct,
            note: tr.note,
            kitchenId: tr.kitchenId,
            id: tr.id // v118: Ensure ID carries over for tracking
          });
        });

        if (!this.lossMode) {
          if (this.currentTab == "odeme") {
            this.$refs.orderList.orderBillEntries = this.orderBillEntries;
            let navigationQuestion = this.$store.getters["selfservice/getNavigationQuestion"];
            if (
              (navigationQuestion.categoryId != null ||
                navigationQuestion.productId != null) &&
              !this.isCakeQuestioned &&
              !cartEntries.some((entry) =>
                (entry.categories || []).some(
                  (category) => category.id == navigationQuestion.categoryId
                )
              )
            ) {
              this.$refs.cakeQuestion.isActive = true;
            } else {
              this.moveOnToOrderList();
            }
          } else {
            let toUpdateCart = this.carts.find(
              (x) => x != null && x.id == this.currentCart.realId
            );

            if (!toUpdateCart) {
              let newCart = {
                id: this.currentCart.realId,
                cartEntries: _.cloneDeep(this.currentCart.cartEntries),
                orderPayments: this.currentCart.orderPayments,
                totalPrice: this.currentCart.totalPrice,
                totalPayedPrice: 0,
                active: true,
                tableId: this.currentCart.realId,
                name: this.currentCart.name,
                paymentGroups: _.cloneDeep(this.currentCart.paymentGroups),
              };
              newCart.isFullTable = true;
              this.$store.dispatch("selfservice/createNewCart", newCart);
              this.$store.dispatch("selfservice/setToUpdateEntry", null);
              this.$store.dispatch("selfservice/setCakeQuestioned", false);
              this.$store.dispatch("selfservice/setCurrentCart", newCart);
              this.$store.dispatch("selfservice/setToUpdateEntry", null);
            } else {
              // v118.Alpha-Final-32: Only update if it's a different cart OR we have new items
              if (toUpdateCart.id !== this.currentCart.id) {
                let clonedToUpdateCart = _.cloneDeep(toUpdateCart);
                if (pendingEntries.length > 0) {
                  // v118: ONLY concat the pending/new entries to the existing table cart
                  clonedToUpdateCart.cartEntries = (clonedToUpdateCart.cartEntries || []).concat(
                    _.cloneDeep(pendingEntries)
                  );

                  // Update totals (NET and ORIGIN) with ONLY new items
                  let pendingTotal = pendingEntries.reduce((sum, entry) => sum + (parseFloat(entry.price) || 0), 0);
                  clonedToUpdateCart.totalPrice += pendingTotal;
                  
                  let pendingOriginTotal = pendingEntries.reduce((sum, entry) => sum + (parseFloat(entry.originPrice || entry.price) || 0), 0);
                  clonedToUpdateCart.totalOriginPrice = (parseFloat(clonedToUpdateCart.totalOriginPrice) || parseFloat(clonedToUpdateCart.totalPrice) || 0) + pendingOriginTotal;

                  // Sync payment groups for NEW items ONLY
                  const pendingGroupIds = pendingEntries.map(e => e.id);
                  const pendingGroups = (this.currentCart.paymentGroups || []).filter(pg => pendingGroupIds.includes(pg.rowIndex));
                  
                  clonedToUpdateCart.paymentGroups = (clonedToUpdateCart.paymentGroups || []).concat(
                    _.cloneDeep(pendingGroups)
                  );
                }
                clonedToUpdateCart.isFullTable = true;
                this.$store.dispatch('selfservice/updateCartsById', [clonedToUpdateCart]);
              }
            }

            // v118.Alpha-Final-7: Restore Table identification while avoiding 422 on 'id'
            let cartPayload = _.cloneDeep(this.currentCart);
            // Only 'id' caused 422, but table info is needed for printer mapping
            cartPayload.id = 0;
            cartPayload.tableId = this.currentCart.realId || this.currentCart.tableId || 0;
            cartPayload.tableNumber = this.currentCart.name || this.currentCart.tableNumber || 0;
            
            cartPayload.printerActive = !!this.printerSettings.enable;
            cartPayload.printerName = this.printerSettings.mainPrinterName;
            cartPayload.branchName = this.$store.state.AppActiveUser.branch.name;
            
            // v118.Alpha-Final-24: Only send pending items to backend AddToCartFromCart
            cartPayload.entries = _.cloneDeep(this.orderBillEntries);
            cartPayload.cartEntries = _.cloneDeep(this.orderBillEntries);
            
            // v118: Also filter payment groups for the payload to match filtered entries
            const pendingEntryIds = pendingEntries.map(e => e.id);
            cartPayload.paymentGroups = (this.currentCart.paymentGroups || []).filter(
              pg => pendingEntryIds.includes(pg.rowIndex)
            );

            // v118.V28 [SID-STABILIZATION]: Masa ID'lerini önceden sabitleyelim (İsteğin ardından sepet temizlenebilir)
            const finalTableId = (this.currentCart.realId || this.currentCart.tableId || this.currentCart.id);
            const finalTableUId = (this.currentCart.branchTableUId || this.currentCart.sid);

            var result = await addToCartFromCart(
              cartPayload,
              finalTableId
            );

            this.orderBillNo = result.data;
            this.totalOriginPrice = this.calculateTotalOriginPrice(
              this.currentCart.paymentGroups || []
            );

            // v118.V25 [AUTH-KITCHEN-PRINT]: Ürünler sepete başarıyla eklendi, mutfağa tetik atıyoruz.
            const finalTableName = this.currentCart.name || this.tableName;
            const sidToPrint = finalTableUId || finalTableId || this.orderBillNo;
            
            if (sidToPrint) {
               // v118.V25 [RACE-CONDITION-FIX]: Veritabanı kaydının tamamlanması için 600ms bekletiyoruz.
               await new Promise(r => setTimeout(r, 600));

               console.log("%c [v118.V25-PRINT-DIAG] SID Captured: ", "background: green; color: white", sidToPrint);
               
               // [v125] Multi-Kitchen Printer Routing: Group items by printer and trigger separately
               const uniquePrinters = new Set();
               pendingEntries.forEach(entry => {
                  const kitchen = this.kitchens.find(k => k.id === entry.kitchenId);
                  const pName = (kitchen && kitchen.printerName) ? kitchen.printerName : "Mutfak";
                  uniquePrinters.add(pName);
               });

               if (uniquePrinters.size === 0) uniquePrinters.add("Mutfak");

               uniquePrinters.forEach(printer => {
                 triggerKitchenPrintBySID(sidToPrint, printer, finalTableName, false)
                   .then(res => console.log(`[v118.V25] Addition Print Trigger Sent (Printer: ${printer}) Success:`, res))
                   .catch(err => console.error(`[v118.V25] Addition Print Trigger (Printer: ${printer}) Failed:`, err));
               });
            } else {
               console.error("%c [v118.V25-PRINT-DIAG] SID NOT FOUND! Printing ABORTED. ", "background: red; color: white", { cart: this.currentCart });
            }

            // Akışa devam et
            this.$emit("switchToTableMap");

            this.$vs.notify({
              color: "success",
              title: "Sipariş Mutfağa Gönderildi",
              text: "Siparişler başarıyla sepete eklendi ve mutfak tetiği gönderildi.",
            });
          }
        } else {
          let obj = {
            entries: this.orderBillEntries,
            branchId: this.$store.state.AppActiveUser.branch.id || 0,
            userId: this.$store.state.AppActiveUser.id || 0,
            type: "Product",
          };
          this.$refs.lossReasonSelect.isActive = true;
          this.$refs.lossReasonSelect.lossData = obj;
        }
      } finally {
        this.isTransaction = false;
      }
    },
    sumOfExtraPrices(extras) {
      if (!extras || !Array.isArray(extras)) return 0;
      let sum = 0;
      extras.forEach((x) => {
        if (x.variants != null && Array.isArray(x.variants) && x.variants.length > 0) {
          x.variants.forEach((y) => {
            sum += (parseFloat(y.price || 0) * (parseFloat(y.quantity || 1)));
          });
        } else {
          sum += (parseFloat(x.price || 0) * (parseFloat(x.quantity || 1)));
        }
      });
      return sum;
    },
    openNewBasket() {
      let id = this.carts.length;
      let newCart = {
        id: "n" + id.toString(),
        cartEntries: [],
        totalPrice: 0,
        active: true,
        tableNumber: "n" + id.toString(),
        tableId: uuid.v1(),
        paymentGroups: [],
        notSeat: true,
      };
      this.$store.dispatch("selfservice/createNewCart", newCart);
      this.$store.dispatch("selfservice/setToUpdateEntry", null);
      this.$store.dispatch("selfservice/setCakeQuestioned", false);
      this.$store.dispatch("selfservice/setCurrentCart", newCart);
      this.$store.dispatch("selfservice/setToUpdateEntry", null);
      this.$emit("handleTableSelection", {
        id: newCart.tableId,
        number: newCart.tableNumber,
      });
    },
    chanceCurrentCart(cart) {
      this.$store.dispatch("selfservice/setCurrentCart", cart);
      this.$store.dispatch("selfservice/setToUpdateEntry", null);
      this.$emit("handleTableSelection", {
        id: cart.tableId,
        number: cart.tableNumber,
      });
    },
    switchToTableMap() {
      this.$emit("switchToTableMap");
    },
    sendOrder: async function (tr) {
      let tempCart = this.$store.getters["selfservice/getCurrentCart"];

      // Find the corresponding payment group and update isSend
      const paymentGroupIndex = tempCart.paymentGroups.findIndex(
        (group) => group.rowIndex === tr.rowIndex
      );

      if (paymentGroupIndex !== -1) {
        tempCart.paymentGroups[paymentGroupIndex].isSend = true;

        // Update the cart in the store
        await setBranchCart({ value: tempCart, tableId: tempCart.tableId });
        // Show a success toast notification
        this.$vs.notify({
          color: "success",
          title: "Sipariş Gönderildi",
          text: "Sipariş başarıyla gönderildi.",
        });
      }
    },
  },
  destroyed() {
    if (this.$refs.lossReasonSelect) {
      this.$refs.lossReasonSelect.isActive = false;
    }
  },
};